const Header = () => {
  return (
    <div id="header" className="header">
      <div className="header-inner">
        <div className="logo">
          <a href="#">
            <img src="/img/logo-light.png" style={{ height: 60 }} />
          </a>
        </div>
        {/* <div className="nav-menu-icon">
          <a>
            <i className="fa fa-bars" />
          </a>
        </div> */}
        <div className="nav-menu singlepage-nav">
          <ul className="nav-menu-inner">
            <li>
              <a href="#intro">Home</a>
            </li>
            <li>
              <a href="#about">About Us</a>
            </li>
            {/* <li>
              <a href="#latest-work">Work</a>
            </li> */}
            <li>
              <a href="#service">Services</a>
            </li>
            {/* <li>
              <a href="#pricing">Pricing</a>
            </li> */}
            {/* <li>
              <a href="#client">Client</a>
            </li> */}
            <li>
              <a href="#mission">Our Mission</a>
            </li>
            <li>
              <a href="#process">Our Process</a>
            </li>

            <li>
              <a href="#contact-us">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
